import MOJEID_STATUSES from '../moje-id/constants';
import { REGISTRATION_TYPES } from './constants';

const preloadedState = {
	authenticated: false,
	username: '',
	email: '',
	password: '',
	firstName: '',
	lastName: '',
	address: '',
	postalCode: '',
	city: '',
	callingCode: '',
	phoneNumber: '',
	year: '',
	month: '',
	day: '',
	dkCprNumber: '',
	dkGamblingRangeId: '',
	acceptMarketingOffers: false,
	acceptTerms: false,
	acceptAccurateInfo: false,
	gender: '',
	country: '',
	currency: '',
	state: '',
	voucherCode: '',
	pesel: '',
	documentType: '',
	documentNumber: '',
	showWelcomeScreen: false,
	isValidateSessionEnabled: true,
	showLoginUsernameAndPassword: false,
	mentorMessages: [],
	showMentorMessageDialog: false,
	showMojeID: false,
	showTransactionLinkFlow: false,
	mojeIDStatus: MOJEID_STATUSES.START,
	cddnRegisterStatus: 'idle',
	registrationType: REGISTRATION_TYPES.FULL_REGISTRATION
};

export default preloadedState;
